import styled from 'styled-components'
import { theme } from 'styled-tools'

export default styled.hr`
	background-color: ${theme('colors.grayfc')};
`
